import type { Theme } from '../../types/theme';

export const miroTheme: Theme = {
  id: 'miro',
  name: 'Miro',
  description: 'Bright yellow accent for visual collaboration and infinite canvas',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/miro/DESIGN.md',
  visualKeywords: ['yellow accent', 'infinite canvas', 'collaboration', 'creative', 'visual'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#050038',
    textSecondary: '#4262e0',
    textMuted: '#4262e0',
    border: '#e8e8f0',
    borderSubtle: '#dedee6',
    primary: '#ffd02f',
    primaryHover: '#ebbc1b',
    primaryActive: '#e1b211',
    accent: '#ffd02f',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'creative',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
